import Select from 'react-select';

const SelectBox = ( { options , setValue , value = '' , ...props } ) => {
    const customStyles = {
        control: (provided) => ({
          ...provided,
            paddingTop: "5px",
            paddingBottom: "5px",
            paddingLeft : "4px" ,
            paddingRight : "4px" ,
            borderColor : "var(--dark)"
        }),
    };

    const handleChange = e => {
        setValue(e.value);      
    }

    const selectedOption = options.find(option => option.value === value);

    return (
        <Select
            options={options}
            className='outline-none focus:border-red-500'
            inputId='select-box-input'
            onChange={handleChange}
            value={selectedOption}
            styles={customStyles}
            {...props}
        />
    );
}

export default SelectBox;